import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import FormGroup from '../../FormGroup';
import Constructor from '../Constructor/Constructor';
import template from '../../../helpers/template';
import CustomNotify from "../../Notify";
import { I18nContext } from 'utils/I18n/context';

const LinkConstructor = (props) => {
    const { t } = useContext(I18nContext);
    const constructorMethods = Constructor(props);
    
    const [state, setState] = useState({
        creativeType: props.creativeType || 'link',
        creativeId: props.creativeId || props.linkId,
        linkId: props.linkId,
        modalIsVisible: props.visible,
        goalEntries: props.goalEntries,
        publisherId: props.publisherId,
        link: {},
        metaParams: {},
        metaParamsmetaParams: {},
        selfieLink: '',
        currentLinkId: '',
        resultLink: '',
        type: props.type,
        codeParams: {},
        modalOptions: {
            link: {
                title: t?.constructors?.createLink || 'Create Link',
                pattern: '{{ link }}'
            },
            container: {
                title: t?.constructors?.createContainer || 'Create Container',
                pattern: '<iframe src="{{ link }}" width="{{ width }}" height="{{ height }}" align="middle">{{ text }}</iframe>'
            }
        },
        saveLinkPresets: props.saveLinkPresets
    });

    useEffect(() => {
        initLink();
    }, []);

    useEffect(() => {
        const isChangeLinkId = state.linkId !== props.linkId;

        setState(prev => ({
            ...prev,
            creativeType: props.creativeType || 'link',
            creativeId: props.creativeId || props.linkId,
            goalEntries: props.goalEntries,
            publisherId: props.publisherId,
            linkId: props.linkId,
            type: props.type,
            selfieLink: '',
            codeParams: props.codeParams || {},
            access: !!constructorMethods.getFirstGoal() && props.access,
            modalIsVisible: props.visible,
            goalEntryId: props.goalEntryId || constructorMethods.getFirstGoal()
        }));

        if (isChangeLinkId) {
            initLink();
        }
    }, [props]);

    const initLink = useCallback(() => {
        if (!state.linkId) {
            return;
        }
        props.getDataLink(state.linkId, successLink);
    }, [state.linkId, props]);

    const successLink = useCallback((data) => {
        setState(prev => ({
            ...prev,
            link: data
        }));
    }, []);

    const getLinkParams = useCallback(() => {
        let linkIdParam = '?l=' + state.linkId,
            selfieLink = state.selfieLink;

        return selfieLink ? linkIdParam + '&sl=' + encodeURIComponent(selfieLink) : linkIdParam;
    }, [state.linkId, state.selfieLink]);

    const getCode = useCallback(() => {
        let code = state.modalOptions[state.type].pattern;
        let params = {
            ...state.codeParams,
            link: constructorMethods.getResultLink(state.link)
        };

        return template(code, params);
    }, [state, constructorMethods]);

    const setParam = useCallback((e) => {
        if (e.target.value.replace(constructorMethods.getAllowChar(), '') !== e.target.value) {
            constructorMethods.onErrorMsg('notAllowCharMsg');
            return false;
        }

        let metaParams = { ...state.metaParams };
        let link = { ...state.link };

        if(typeof link.params === "string") {
            link.params = JSON.parse(link.params);
        }

        metaParams[e.target.placeholder] = e.target.value;

        if(!state.link.params) {
            link['params'] = {};
        }

        link.params[e.target.placeholder] = e.target.value;
        setState(prev => ({
            ...prev,
            metaParams: metaParams,
            link: link
        }));
    }, [state, constructorMethods]);

    if(undefined === state.modalOptions[state.type]) {
        return '';
    }

    if ("object" === typeof state.link && 0 === Object.keys(state.link).length && state.modalIsVisible) {
        return '';
    }
    if (undefined === state.link && state.modalIsVisible) {
        CustomNotify(t?.constructors?.cantCreateUrlForCreativeNoLinksAvailable || 'Error', 'error');
        return '';
    }

    let options = state.modalOptions[state.type];

    return (
        <div className="link-construrtor">
            {!state.access
                ? <CustomModal
                    visible={state.modalIsVisible}
                    onClose={props.onClose}
                    onConfirm={props.onClose}
                    confirmName={t?.constructors?.confirm || 'Confirm'}
                    title={options.title}
                    areNoControls={true}
                >

                    <div className="row row-line">
                        <div className="col-sm-12">
                            <span>{t?.constructors?.getAccess || 'Get Access'}.</span>
                        </div>
                    </div>
                </CustomModal>
                : <CustomModal
                    visible={state.modalIsVisible}
                    onClose={props.onClose}
                    onConfirm={constructorMethods.onCopyButtonClick}
                    confirmName={t?.constructors?.copy || 'Copy'}
                    bsSize={'sm'}
                    title={options.title}
                >
                    {constructorMethods.renderGoalEntries()}

                    {constructorMethods.renderParams('link')}

                    {constructorMethods.renderSubMetaParams('link')}

                    {state.link.selfie_link
                        ? constructorMethods.renderSelfieLink()
                        : null
                    }

                    <FormGroup
                        label={t?.constructors?.result || 'Result'}
                    >
                        <textarea
                            className="form-control"
                            value={getCode()}
                            ref={constructorMethods.resultRef}
                            readOnly={true}
                        />
                    </FormGroup>
                </CustomModal>
            }
        </div>
    );
};

LinkConstructor.propTypes = {
    offer: PropTypes.object.isRequired,
    goalEntryId: PropTypes.string,
    linkId: PropTypes.string,
    visible: PropTypes.bool,
    access: PropTypes.bool,
    type: PropTypes.string,
    getDataLink: PropTypes.func,
    onClose: PropTypes.func
};

LinkConstructor.defaultProps = {
    type: 'link',
    getDataLink: () => {},
    onClose: () => {}
};

export default LinkConstructor;